import {
  getAllAmbulanceEmployeeSuccess,
  getAllAmbulanceEmployeeFailure,
  addAmbulanceEmployeeSuccess,
  addAmbulanceEmployeeFailure,
  editAmbulanceEmployeeSuccess,
  editAmbulanceEmployeeFailure,
  deleteAmbulanceEmployeeSuccess,
  deleteAmbulanceEmployeeFailure
} from "../constants/ambulanceEmployeeMapping";

const initialState = {
  isProcessing: false,
  isError: false,
  data: {
    object: [],
    totalCount: 0,
  },
  addError: false,
  editError: false,
  deleteError: false
};


function handleReducer(state = initialState, action) {
  switch (action.type) {
    case getAllAmbulanceEmployeeFailure:
      return { ...state, isError: true };

    case getAllAmbulanceEmployeeSuccess:
      return { ...state, data: action.payload, isError: false };

    case addAmbulanceEmployeeSuccess:
      return {
        ...state,
        data: [...state.data, action.payload],
        addError: false
      };

    case addAmbulanceEmployeeFailure:
      return {
        ...state,
        addError: true
      };

    case editAmbulanceEmployeeSuccess:
      debugger
      return {
        ...state,
        data: {
          ...state.data,
          object: state.data.object.map((item) =>
            item.ambulance?.id === action.payload.ambulance.id
              ? { ...item, employeeList: action.payload.employeeList }
              : item
          ),
        },
        editError: false
      };

    case editAmbulanceEmployeeFailure:
      return {
        ...state,
        editError: true
      };

    case deleteAmbulanceEmployeeSuccess:
      return {
        ...state,
        data: state.data.filter((item) => item.id !== action.payload),
        deleteError: false
      };

    case deleteAmbulanceEmployeeFailure:
      return {
        ...state,
        deleteError: true
      };

    default:
      return state;
  }
}

export const ambulanceEmployeeMappingReducer = (state, action) => {
  return handleReducer(state, action);
};
